import { render, staticRenderFns } from "./CourseCreditPage.vue?vue&type=template&id=c709620e&scoped=true"
import script from "./CourseCreditPage.vue?vue&type=script&lang=js"
export * from "./CourseCreditPage.vue?vue&type=script&lang=js"
import style0 from "./CourseCreditPage.vue?vue&type=style&index=0&id=c709620e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c709620e",
  null
  
)

export default component.exports